export const RolesData = `
  id
  name
  description
  permissions
  isActive
`;
